import React from 'react'

import FormatCurrency from 'components/Common/FormatCurrency'
import { pluralizeToString } from 'lib/string/pluralize'
import Caption from 'components/Luxkit/Typography/Caption'
import RadioInput from 'components/Luxkit/Radio/RadioInput'
import { Divider } from '../../Shared/Divider'
import ListItem from 'components/Luxkit/List/ListItem'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Typography from 'components/Luxkit/Typography/Typography'

interface Props {
  bonusInclusions: boolean;
  checked: boolean;
  name: number;
  nights: number;
  onSwitchPackageDuration: () => void;
  price: number;
  hasMemberPrice: boolean;
}

function BnblSwitchPackageDurationItem({ checked, name, nights, onSwitchPackageDuration, price, hasMemberPrice }: Props) {
  return (
    <>
      <ListItem
        title={pluralizeToString('night', nights)}
        onClick={onSwitchPackageDuration}
        startIcon={<RadioInput name={name.toString()} checked={checked} />}
      >
        <div>
          <Caption colour="neutral-three" variant="medium">From</Caption>
          <Typography wrap="no-wrap">
            <BodyText as="span" variant="large" colour={hasMemberPrice ? 'loyalty' : undefined}>
              <FormatCurrency value={price} />
            </BodyText>{' '}
            <Caption as="span" colour="neutral-three" variant="medium">total</Caption>
          </Typography>
        </div>
      </ListItem>
      <Divider />
    </>
  )
}

export default BnblSwitchPackageDurationItem
